import React from 'react';
import { Star, MessageSquare, CheckCircle, Quote } from 'lucide-react';
import { reviews } from '../data/reviews';
import { useLanguage } from '../context/LanguageContext';

export default function Reviews() {
  const { lang, t } = useLanguage();

  return (
    <section id="yorumlar" className="py-24 relative bg-slate-50 border-t border-slate-200 overflow-hidden w-full">
      
      {/* Background Soft Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[700px] h-[350px] bg-amber-100/30 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-100 border border-amber-300 text-amber-800 text-xs font-bold uppercase tracking-wider mb-3 shadow-sm">
            <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
            <span>{t.reviews.tag}</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
            {t.reviews.title1} <span className="gold-gradient-text">{t.reviews.title2}</span>
          </h2>
          <p className="mt-4 text-sm sm:text-base text-slate-600">
            {t.reviews.subtitle}
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => {
            const comment = typeof review.comment === 'object' ? (review.comment[lang] || review.comment.nl) : review.comment;
            const serviceName = typeof review.service === 'object' ? (review.service[lang] || review.service.nl) : review.service;
            const reviewDate = typeof review.date === 'object' ? (review.date[lang] || review.date.nl) : (review.date || review.relativeTime);

            return (
              <div
                key={review.id}
                className="rounded-3xl p-6 bg-white border border-slate-200 hover:border-amber-400 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between group"
              >
                <div>
                  {/* Top Bar: Stars & Service Pill */}
                  <div className="flex items-center justify-between gap-2 mb-4">
                    <div className="flex items-center gap-1 text-amber-400">
                      {[...Array(review.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                      ))}
                    </div>
                    <span className="text-[10px] font-bold text-amber-800 bg-amber-50 px-2 py-0.5 rounded border border-amber-200">
                      {serviceName}
                    </span>
                  </div>

                  {/* Comment */}
                  <p className="text-xs sm:text-sm text-slate-700 leading-relaxed italic">
                    "{comment}"
                  </p>
                </div>

                {/* Author Info */}
                <div className="mt-6 pt-4 border-t border-slate-100 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 text-white font-bold text-xs flex items-center justify-center shadow-sm">
                      {review.avatar}
                    </div>
                    <div>
                      <h4 className="text-xs font-bold text-slate-900">{review.author}</h4>
                      <span className="text-[10px] text-slate-400">{reviewDate} &bull; Google</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-1 text-[11px] text-emerald-600 font-semibold" title="Geverifieerde Klant">
                    <CheckCircle className="w-3.5 h-3.5" />
                    <span>{t.reviews.verifiedCustomer}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
